<app-hero [data]="heroData"></app-hero>
<div class="row m-0 mt-5"></div>
<!--desktop view-->
<section class="d-none d-lg-block">
  <div class="container grid mt-5">
    <div class="row mt-5 p-0 m-0">
      <div class="frame mt-5 mb-xxl-5 px-3">
        <h2 class="blue-50 text-center bold">La nostra mission</h2>
      </div>

      <div class="arg-container grid mt-5 mb-5">
        <div class="row">
          <div class="col-xxl-4 mt-xxl-5">
            <div class="arg-card">
              <img [src]="cardList[0].img" class="balloon" width="106.72px" alt="" aria-hidden="true" />
              <p class="course-desc" [innerHTML]="cardList[0].text"></p>
            </div>
          </div>

          <div class="col-xxl-4 mt-5">
            <div class="arg-card">
              <img [src]="cardList[1].img" class="balloon" width="106.72px" alt="" aria-hidden="true" />
              <p class="course-desc" [innerHTML]="cardList[1].text"></p>
            </div>
          </div>

          <div class="col-xxl-4 mt-5">
            <div class="arg-card">
              <img [src]="cardList[2].img" class="balloon" width="106.72px" alt="" aria-hidden="true" />
              <p class="course-desc" [innerHTML]="cardList[2].text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--mobile view-->
<section class="d-block d-md-block d-lg-none">
  <div class="row mt-5 p-0 m-0" #myElement2>
    <div class="frame mt-5 mb-xxl-5 px-3">
      <h2 class="blue-50 text-center bold">La nostra mission</h2>
    </div>

    <ng-container *ngFor="let course of cardList">
      <div>
        <div
          class="mb-4"
          *ngIf="course.id === cardSelected"
          style="margin: auto"
        >
          <div class="frame mt-5 arg-card mb-xxl-5 px-3">
            <img
              [src]="course.img"
              width="106.72px"
              [class]="course.class"
              alt="Un mondo di corsi per mettersi in gioco"
             
            />

            <div class="course-txt p-3">
              <p class="course-desc" [innerHTML]="course.text"></p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="row d-block d-md-block d-lg-none">
    <div class="col pointer-slide" style="padding-bottom: 40px">
      <div (click)="changeSlideCard(1)" class="pointer">
        <img src="assets/img/slide-selected.svg" alt="" aria-hidden="true" *ngIf="cardSelected == 1" />
        <img src="assets/img/slide-unselected.svg" alt="" aria-hidden="true" *ngIf="cardSelected != 1" />
      </div>
      <div (click)="changeSlideCard(2)" class="pointer">
        <img src="assets/img/slide-selected.svg" alt="" aria-hidden="true" *ngIf="cardSelected == 2" />
        <img src="assets/img/slide-unselected.svg" alt="" aria-hidden="true" *ngIf="cardSelected != 2" />
      </div>
      <div (click)="changeSlideCard(3)" class="pointer">
        <img src="assets/img/slide-selected.svg" alt="" aria-hidden="true" *ngIf="cardSelected == 3" />
        <img src="assets/img/slide-unselected.svg" alt="" aria-hidden="true" *ngIf="cardSelected != 3" />
      </div>
    </div>
  </div>
</section>

<div class="row mb-5 p-0 m-0 mt-5">
  <div class="col-2"></div>
  <div class="col-8 text-center">
    <button class="btn-lightblue m-custom" routerLink="/corsi-coding">
      <span class="button-txt">Vai ai corsi</span>
    </button>
  </div>
  <div class="col-2"></div>
</div>

<div class="bck-citazione-container">
  <div class="citazione-container">
    <div class="desc-start">
      <img src="../../../assets/img/quote_sx.svg" alt="" aria-hidden="true" />
    </div>
    <div class="desc-cit">
      “In una comunità, o in un gruppo qualsiasi, i numeri contano e possono
      fare la differenza, ma al suo interno contano ancor di più l'armonia e il
      rispetto reciproco tra quelli che li rappresentano e li aiutano a
      moltiplicarsi.”
    </div>
    <div class="desc-end">
      <img src="../../../assets/img/quote_dx.svg" alt="" aria-hidden="true" />
    </div>
  </div>
  <div class="cit-sign">Jean-Paul Malfatti</div>
</div>

<div class="mt-5" style="z-index: 0 !important">
  <div class="container grid">
    <div class="row text-center p-2 p-xl-5">
      <h2 class="blue-50 bold mb-3">Gli obiettivi di Easycode</h2>
      <p class="mt-3 course-desc">
        Easycode è un progetto educativo digitale nato nel 2020 e rivolto a
        bambini e ragazzi dai 6 ai 18 anni per insegnare il coding, il pensiero
        computazionale, la logica e il cooperative learning. 
      </p>
    </div>
  </div>
</div>

<div class="container grid mb-5 p-3">
  <div class="row mt-0 p-0">
    <div class="col-12 cards-col">
      <div class="school-card p-4">
        <img
          src="assets/img/light.svg"
          alt="pensiero computazionale"
         
        />
        <p class="title-desc" style="text-align: start">
          <span style="font-weight: bold">Promuovere creatività e </span
          ><span style="color: rgba(120, 60, 215, 1); font-weight: bold">
            pensiero computazionale</span
          >;: Easycode incoraggia gli studenti a pensare in modo creativo e a
          risolvere i problemi in modo logico e sistematico, sviluppando così il
          pensiero computazionale.
        </p>
      </div>
      <div class="school-card p-4">
        <img
          src="../../../assets/img/img-sc2.svg"
          alt="pensiero computazionale"
         
        />
        <p class="title-desc" style="text-align: start">
          <span style="font-weight: bold">Sviluppare fiducia in se stessi</span
          >: Easycode aiuta gli studenti a sviluppare la fiducia in se stessi e
          la resilienza - incoraggiandoli a sperimentare, a fare errori e a
          imparare dai loro sbagli.
        </p>
      </div>
      <div class="school-card p-4">
        <img
          src="../../../assets/img/img-sc3.svg"
          alt="insegnamento del coding"
         
        />
        <p class="title-desc" style="text-align: start">
          <span style="font-weight: bold">Inclusione e collaborazione</span>: il
          nostro progetto è accessibile a tutti gli studenti e promuove la
          collaborazione fra loro, favorendo lo sviluppo di competenze sociali e
          di lavoro di squadra.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center m-0 mt-3 mb-5">
  <button class="btn-lightblue mt-5 progetto-btn" routerLink="/piattaforma-di-apprendimento">
    <span class="button-txt">Vai alla piattaforma</span>
  </button>
</div>


<div class="row m-0 bg-v neutral-00">
  <div class="container grid wwo">
    <div class="row mt-0 my-xl-5 py-5">
      <div
        class="col-xl-4 mb-5 mb-xl-0 d-flex justify-content-center align-items-center"
      >
        <img
          src="assets/img/nascita.svg"
          class="ec-pt w1"
          alt="progetto educativo digitale nato nel 2020"
         
        />
      </div>
      <div
        class="col-xl-4 my-5 my-xl-0 d-flex justify-content-center align-items-center"
      >
        <img
          src="assets/img/sede.svg"
          class="ec-pt w2"
          alt="sede a Milano"
         
        />
      </div>
      <div
        class="col-xl-4 mt-5 mt-xl-0 d-flex justify-content-center align-items-center"
      >
        <img
          src="assets/img/obiettivo.svg"
          class="ec-pt ob"
          alt="progetto educativo digitale nato nel 2020"
         
        />
      </div>
    </div>
  </div>
</div>

<div class="row  m-0 p-5">
  <div class="container grid team">
    <div class="row text-center p-3">
      <h2 class="blue-50 bold">Il team</h2>
      <p class="course-desc mt-3">
        Il team di Easycode è composto da persone con la passione per l’educazione al digitale e per la formazione.
      </p>
    </div>
  </div>
</div>
<div class="row m-0 mt-3 px-4 mb-5">
  <div
    class="user-card mt-5 d-xl-inline-flex"
    *ngFor="let user of usersList | slice : 0 : count"
  >
    <div class="user-img d-flex justify-content-center align-items-center">
      <img
        [src]="user.img"
        alt="{{ user.alt }}"
       
        class="mt-3 mt-xl-0"
      />
    </div>
    <div class="container d-flex align-items-center">
      <div class="user-desc p-2 p-xl-5 m-0 m-xl-3">
        <p class="user-txt mt-3 mt-xl-0">{{ user.desc }}</p>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-5">
    <button
      class="btn show-more"
      *ngIf="usersList.length > 4 && count == 4"
      (click)="count = usersList.length"
    >
      VEDI TUTTI
    </button>
  </div>

  <div class="d-flex justify-content-center">
    <button class="btn show-less" *ngIf="count != 4" (click)="count = 4">
      MOSTRA MENO
    </button>
  </div>
</div>

<div class="row m-0 p-5"></div>
<app-iscriviti></app-iscriviti>
